import React from "react";
import { Container, Form, Row, Col, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FetchCandidaterescheduleList,
  CandidateRescheduleStatusChange,
} from "../../services/candidaterescheduleService";
import { getRangeDateTimeString } from "helpers/common";
import { getUserInfo, getUserToken } from "helpers/authHelper";
import DatePicker from "react-datepicker";
import { utils } from "react-modern-calendar-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCompanyTimezoneDateTime, getDeviceInfo } from "helpers/utils";
import api from "../../api"
import moment from "moment";
import cross from "../../assets/images/icon/cross.svg";

import edit_icon from "../../assets/images/icon/edit.svg";
import eye_icon from "../../assets/images/icon/eye7.png";
import delete_icon from "../../assets/images/icon/action_3.svg";
import { decryptDataFromArray } from "helpers/EncDec";

function CandidaterescheduleList(props) {
  const userInfo = getUserInfo();

  const [rescheduleData, setRescheduleData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [interViewers, setinterViewers] = useState([]);
  const [formData, setFormData] = useState({
    int_schedule_date: "",
    int_schedule_time: "",
    interview_title: "",
    interviewer_time: interViewers?.[0]?.value,
    address: "",
    req_documents: "",
    meeting_type: 0,
    teams_interview: false,
  });

  const teamsIntegrated = userInfo?.teams_integration || false;

  const [int_start_time, setStartTime] = useState("");
  const [int_end_time, setEndTime] = useState("");

  const { interviewid } = useParams();
  // Fetch Faqs listing data

  useEffect(() => {
    fetchinterViewers();
    getRescheduleRequests();
  }, []);

  const getRescheduleRequests = async () => {
    await FetchCandidaterescheduleList(interviewid)
      .then(res => {
        //console.log('24:responsedata',res.data.data)
        if (res.data.status) {
          setRescheduleData(res.data.data);
        } else {
          toast.error("No data Available");
        }
      })
      .catch(err => {
        toast.error("No data Available");
      });
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // Validate int_schedule_date
    if (!int_start_time) {
      newErrors.int_start_time = "This field is required";
      valid = false;
    }

    // Validate int_schedule_time
    if (!int_end_time) {
      newErrors.int_end_time = "This field is required";
      valid = false;
    }

    if (
      new Date(int_end_time).getTime() - new Date(int_start_time).getTime() >
      3 * 60 * 60000
    ) {
      newErrors.int_end_time =
        "Cannot schedule interview of more than 3 hours.";
      valid = false;
    }
    if (Date.parse(int_start_time) - Date.parse(new Date()) < 0) {
      newErrors.int_start_time = "Start Date & Time cannot be in the past";
      valid = false;
    }
    if (Date.parse(int_end_time) - Date.parse(int_start_time) < 0) {
      newErrors.int_end_time =
        "End Date & Time cannot be before Start Date & Time.";
      valid = false;
    }
    if (Date.parse(int_start_time) === Date.parse(int_end_time)) {
      newErrors.int_end_time =
        "End Date & Time and Start Date & Time cannot be the same.";
      valid = false;
    }

    // Validate interview_title
    if (!formData.interview_title) {
      newErrors.interview_title = "Interview title is required";
      valid = false;
    }

    // Validate interviewer_time
    if (!formData.interviewer_time) {
      newErrors.interviewer_time = "Interviewer is required";
      valid = false;
    }

    // Validate address
    if (!formData.address && formData.meeting_type === 0) {
      newErrors.address = "Address is required";
      valid = false;
    }
    if (
      !formData.address &&
      formData.meeting_type === 1 &&
      !formData?.teams_interview
    ) {
      newErrors.address = "Meeting Link is required";
      valid = false;
    }

    // Validate req_documents
    // if (!formData.req_documents) {
    //   newErrors.req_documents = "Valid Documents are required";
    //   valid = false;
    // }

    setErrors(newErrors);
    return valid;
  };

  const [currentItrDetails, setCurrentItrDetails] = useState(null);

  const handleToggleForm = itr_details => {
    setIsFormVisible(prev => !prev);
    setCurrentItrDetails(itr_details); // Save itr_details to state
  };

  useEffect(() => {
    if (interViewers?.length > 0 && currentItrDetails && isFormVisible) {
      let interviewer = interViewers.find(
        el => el?.id === currentItrDetails?.Scheduleinterview?.user?.id
      );

      setFormData({
        interview_title:
          currentItrDetails?.Scheduleinterview?.interview_title || "",
        interviewer_time: interviewer?.value || interViewers?.[0]?.value,
        address: "",
        req_documents: "",
        meeting_type: 0,
        teams_interview: false,
        reschedule_itr_id: currentItrDetails?.id,
        roundStatus: "Scheduled",
        itr_id: currentItrDetails?.Scheduleinterview?.id,
        appl_id: currentItrDetails?.appl_id,
        int_schedule_time: currentItrDetails?.int_schedule_time,
      });

      const startTime = currentItrDetails?.int_start_time
        ? new Date(currentItrDetails.int_start_time)
        : null;
      const endTime = currentItrDetails?.int_end_time
        ? new Date(currentItrDetails.int_end_time)
        : null;

      if (startTime) {
        handleStartDateChange(startTime);
      }

      if (endTime) {
        handleEndDateChange(endTime);
      }
    }
  }, [interViewers, currentItrDetails, isFormVisible]);

  const fetchinterViewers = async () => {
    await api
      .get(`${process.env.REACT_APP_API_URL}/admin/user/fetch-interviewers`)
      .then(response => {
        console.log(response.data, "response");
        let result = decryptDataFromArray(response.data);
        console.log(result, "result");
        let { userList, success } = result;
        let data = userList?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.id,
        }));
        setinterViewers(data);
        console.log(data, "data");
      })
      .catch(err => console.log("Error:::", err));
  };

  const handleStartDateChange = date => {
    setStartTime(
      moment(getCompanyTimezoneDateTime(date)).format("YYYY-MM-DDTHH:mm")
    );
    // generateExcludedTimes("start", date);
  };
  const handleEndDateChange = date => {
    setEndTime(
      moment(getCompanyTimezoneDateTime(date)).format("YYYY-MM-DDTHH:mm")
    );
    // generateExcludedTimes("end", date);
  };

  const changeHandlers = e => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const convertDateFormat = dateString => {
    // Create a new Date object from the given date string
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const handleRescheduleSubmit = async e => {
    e.preventDefault();

    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    let ChangedEventDate = moment(
      getCompanyTimezoneDateTime(int_start_time)
    ).utc();
    let ChangedEndEventDate = moment(
      getCompanyTimezoneDateTime(int_end_time)
    ).utc();

    let newFormData = JSON.parse(JSON.stringify(formData));

    const dynamicApplId = newFormData?.reschedule_itr_id;
    const formattedDate = convertDateFormat(ChangedEventDate);
    newFormData.int_schedule_date = formattedDate;
    newFormData.int_start_time = ChangedEventDate;
    newFormData.int_end_time = ChangedEndEventDate;
    newFormData.time_zone_id = userInfo?.company_time_zone_id;
    let device_info = await getDeviceInfo(navigator);
    // let roundItem = roundListData?.find(el => el?.isCurrentRound);
    newFormData = {
      ...newFormData,
      device_info: device_info,
      old_status:
        newFormData?.interview_title + " - " + newFormData?.roundStatus,
      new_status: newFormData?.interview_title + " - Rescheduled",
      appl_id: newFormData?.appl_id,
      int_schedule_time: newFormData?.int_schedule_time,
    };

    console.log(newFormData, "newFormData");

    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/admin/schedule/rescheduled-status-change/${dynamicApplId}`,
        newFormData
      );
      toast.success("Interview Rescheduled successfully");
      setIsFormVisible(false);
      getRescheduleRequests();
    } catch (error) {
      console.log(error);
      toast.error("Error rescheduling interview:");
    }
  };

  // Bootstrap table columns
  const columns = [
    {
      text: "id",
      dataField: "interview_id",
    },
    {
      dataField: "applied_job.name",
      text: "Name",
    },
    {
      dataField: "applied_job.email_id",
      text: "Email Id",
    },
    {
      dataField: "applied_job.mobile",
      text: "Mobile No.",
    },
    {
      dataField: "applied_job.highest_qualification",
      text: "Education",
    },
    {
      dataField: "int_schedule_date",
      text: "Interview Scheduled Date & Time",
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        return `${getRangeDateTimeString(
          new Date(row?.int_start_time),
          new Date(row?.int_end_time),
          row?.Scheduleinterview?.master_time_zone?.offset || ""
        )} ${row?.Scheduleinterview?.master_time_zone?.alias || ""}`;
      },
    },
    {
      dataField: "",
      text: "Actions",
      formatter: (cell, row) => {
        let appl_id = row.appl_id;
        return (
          <div className="d-flex gap-2 blue-icon-gap  candiate-icon">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`../candidate_consolidate/view-details/${appl_id}`}
                title="View Details"
              >
                {/* <i
                className="mdi mdi-eye-outline font-size-18"
                id="logintooltip"
                style={{ color: "black" }}
              ></i> */}
                <img src={eye_icon} alt="delete_icon" />
                <span>View</span>
              </Link>
            </div>

            <div className="action-one small-img edit">
              <div
                onClick={() => handleToggleForm(row)}
                className="text-success blue-icon blue-color4"
                style={{ cursor: "pointer" }}
                to="#"
                title="Approve"
              >
                {/* <i
                className="mdi mdi-tooltip-edit font-size-18"
                id="logintooltip"
                style={{ color: "black" }}
              ></i> */}
                <img src={edit_icon} alt="delete_icon" />
                <span>Edit</span>
              </div>
            </div>

            <div className="action-one small-img">
              <div
                onClick={() => handleRescheduleStatusChange(row.id, "Rejected")}
                className="text-success blue-icon blue-color4"
                style={{ cursor: "pointer" }}
                to="#"
                title="Reject"
              >
                {/* <i
                  className="mdi mdi-block-helper font-size-18"
                  id="logintooltip"
                  style={{ color: "black" }}
                ></i> */}
                <img src={delete_icon} alt="delete_icon" />
                <span>Reject</span>
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing rows {from} to {to} of {size}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const hasIdBelow10 = rescheduleData.some(item => item.id < 10);

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (rescheduleData.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [rescheduleData.length]);

  // Status Change to approved
  const handleRescheduleStatusChange = async (id, status) => {
    const userConfirmed = window.confirm("Are you sure you want to proceed?");
    if (userConfirmed) {
      // console.log('User clicked OK, proceeding...');
      await CandidateRescheduleStatusChange(id, status)
        .then(res => {
          // console.log("response", res.status);
          if (res.status == 200) {
            toast.success("Candidate reschedule status changed successfully.");
            FetchCandidaterescheduleList(interviewid);
            //window.location.reload();
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    } else {
      toast.error("User canceled, action aborted.");
    }
  };

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* <Row className="mb-3">
            <Col sm="6">
              <h5 className="text-uppercase">Candidate reschedule List </h5>
            </Col>
            <Col
              sm="6"
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            ></Col>
          </Row> */}

          <div className="joblist-container">
            <Row className="mb-3 align-items-center py-2">
              <Col lg="6" md="6">
                <h5 className="text-uppercase heading-one">
                  Candidate reschedule List
                </h5>
              </Col>
            </Row>
          </div>
          {successMessage && (
            <div class="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}
          <Row>
            <Col lg={12}>
              <div className="outerTab-box-wrapper below-vacancy">
                <div className="timeto-hire-card userlist">
                  <div className="tabel-application tabel-application-auto table-responsive white-space-row">
                    <ToolkitProvider
                      keyField="head1"
                      data={rescheduleData}
                      columns={columns}
                      search
                    >
                      {props => (
                        <div className="table-custome-class range-custome">
                          <BootstrapTable
                            noDataIndication={
                              <p className="text-center">No Data Available.</p>
                            }
                            {...props.baseProps}
                            pagination={paginationFactory(options)}
                            options={options}
                            striped
                            hover
                            rowClasses={rowClasses}
                            wrapperClasses="table-wrapper"
                            bodyRef={tbodyRef}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Modal
            size="xl"
            show={isFormVisible}
            onHide={() => handleToggleForm()}
            className="edit-modal-card asseentModal"
          >
            {/* <Modal.Header closeButton>
              <Modal.Title>Reschedule Interview</Modal.Title>
            </Modal.Header> */}
            <Modal.Body>
              <div className="filters-cards-cross pb-3">
                <div className="filter-content">
                  <h4>Reschedule Interview</h4>
                </div>
                <div
                  className="filter-content cross"
                  onClick={handleToggleForm}
                >
                  <img src={cross} alt="" />
                </div>
              </div>
              <Form
                onSubmit={e => {
                  handleRescheduleSubmit(e);
                }}
              >
                <div className="form-group">
                  <div className="row">
                    <div
                      id="int_schedule_date-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <span className="text-danger">*</span>
                      <label>Start Date & Time:</label>
                      <DatePicker
                        id="int_start_time"
                        name="int_start_time"
                        selected={
                          int_start_time ? new Date(int_start_time) : ""
                        }
                        onChange={value => {
                          if (value >= new Date()) {
                            handleStartDateChange(value);
                            setErrors({ ...errors, int_start_time: "" });
                          } else {
                            setErrors({
                              ...errors,
                              int_start_time: "Cannot Select Past Dates.",
                            });
                          }
                        }}
                        selectsStart
                        startDate={
                          int_start_time ? new Date(int_start_time) : ""
                        }
                        endDate={int_end_time ? new Date(int_end_time) : ""}
                        minDate={new Date()}
                        showTimeSelect
                        placeholderText="dd-mm-yyyy --:-- --"
                        timeFormat="h:mm aa"
                        required={true}
                        minimumDate={utils().getToday()}
                        timeIntervals={15}
                        shouldHighlightWeekends
                        calendarPopperPosition="bottom"
                        autoComplete="off"
                        dateFormat="dd-MMM-yyyy h:mm aa"
                        timeCaption="Time"
                        className={`form-control`}
                        onKeyDown={e => e.preventDefault()}
                        disabled
                      />
                      <small>
                        Note : Max Duration for any interview is 3 hr.
                      </small>
                      {errors?.int_start_time && (
                        <p className="text-danger">{errors?.int_start_time}</p>
                      )}
                    </div>
                    <div
                      id="int_schedule_date-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <span className="text-danger">*</span>
                      <label>End Date & Time:</label>
                      <DatePicker
                        id="int_end_time"
                        name="int_end_time"
                        selected={int_end_time ? new Date(int_end_time) : ""}
                        onChange={value => {
                          if (value >= new Date()) {
                            handleEndDateChange(value);
                            setErrors({ ...errors, int_end_time: "" });
                          } else {
                            setErrors({
                              ...errors,
                              int_end_time: "Cannot Select Past Dates.",
                            });
                          }
                        }}
                        selectsEnd
                        startDate={
                          int_start_time ? new Date(int_start_time) : ""
                        }
                        endDate={int_end_time ? new Date(int_end_time) : ""}
                        minDate={
                          int_start_time ? new Date(int_start_time) : new Date()
                        }
                        minimumDate={
                          int_start_time ? int_start_time : utils().getToday()
                        }
                        showFullMonthYearPicker
                        showTimeSelect
                        placeholderText="dd-mm-yyyy --:-- --"
                        timeFormat="h:mm aa"
                        required={true}
                        timeIntervals={15}
                        shouldHighlightWeekends
                        calendarPopperPosition="bottom"
                        autoComplete="off"
                        dateFormat="dd-MMM-yyyy h:mm aa"
                        timeCaption="Time"
                        className={`form-control`}
                        onKeyDown={e => e.preventDefault()}
                        disabled
                      />
                      {errors?.int_end_time && (
                        <p className="text-danger">{errors?.int_end_time}</p>
                      )}
                    </div>
                    <div
                      id="interview-group"
                      className="form-group form-group-lg col-sm-6 formvisible mt-3"
                    >
                      <span className="text-danger">*</span>
                      <label>Enter Interview Title:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={changeHandlers}
                        name="interview_title"
                        id="interview_title"
                        placeholder="Enter Interview Title"
                        value={formData?.interview_title}
                        disabled
                      />
                      {errors?.interview_title && (
                        <p className="text-danger">{errors?.interview_title}</p>
                      )}
                    </div>
                    <div
                      id="interviewer-group"
                      className="form-group form-group-lg col-sm-6 formvisible mt-3"
                    >
                      <span className="text-danger">*</span>
                      <label>Select Interviewer:</label>
                      <select
                        id="interviewere_time"
                        onChange={changeHandlers}
                        name="interviewer_time"
                        className="form-select  form-control"
                        data-width="100%"
                        data-size="10"
                        disabled
                        title="Select Interviewer"
                        value={formData?.interviewer_time}
                      >
                        <option Selected>Select Interviewer</option>
                        {interViewers?.map(el => {
                          return <option value={el?.value}>{el?.label}</option>;
                        })}
                      </select>
                      {errors?.interviewer_time && (
                        <p className="text-danger">
                          {errors?.interviewer_time}
                        </p>
                      )}
                    </div>
                    <Row className="mt-2">
                      <Col md={6}>
                        <div
                          id="interviewer-group"
                          className="form-group form-group-lg formvisible mt-3"
                        >
                          <span className="text-danger">*</span>{" "}
                          <label>Select Interview Type:</label>
                          <select
                            id="interviewType"
                            onChange={e => {
                              setFormData(prevFormData => ({
                                ...prevFormData,
                                meeting_type: parseInt(e.target.value),
                              }));
                            }}
                            name="interviewType"
                            className="form-select  form-control"
                            data-width="100%"
                            data-size="10"
                            title="Select Interview Type"
                            value={formData?.meeting_type}
                          >
                            <option value={0}>Offline</option>
                            <option value={1}>Online</option>
                          </select>
                        </div>
                      </Col>
                      {formData?.meeting_type === 1 && teamsIntegrated && (
                        <div
                          id="address-group"
                          className="form-group form-group-lg col-sm-6 formvisible mt-3"
                        >
                          <label>Schedule on Teams:</label> <br />
                          <div className="">
                            <label
                              className="switch mt-1"
                              htmlFor={"tableSwitch"}
                            >
                              <input
                                type="checkbox"
                                id={`tableSwitch`}
                                onClick={e => {
                                  setFormData(prevFormData => ({
                                    ...prevFormData,
                                    teams_interview: e.target.checked,
                                  }));
                                }}
                                checked={formData?.teams_interview}
                              />
                              <div className="slider round"></div>
                            </label>
                          </div>
                        </div>
                      )}

                      <div
                        id="address-group"
                        className="form-group form-group-lg col-sm-6 formvisible mt-3"
                      >
                        {formData?.meeting_type === 0 && (
                          <>
                            <span className="text-danger">*</span>
                            <label>Enter Offline Address:</label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={changeHandlers}
                              name="address"
                              id="address"
                              placeholder="Enter Address"
                              value={formData?.address}
                            />
                            {errors?.address && (
                              <p className="text-danger">{errors?.address}</p>
                            )}
                          </>
                        )}
                        {formData?.meeting_type === 1 &&
                          !formData?.teams_interview && (
                            <>
                              <span className="text-danger">*</span>{" "}
                              <label>Meeting Link:</label> <br />
                              <input
                                type="text"
                                className="form-control"
                                onChange={changeHandlers}
                                name="address"
                                id="address"
                                placeholder="Enter Meeting Link"
                                value={formData?.address}
                              />
                              {errors?.address && (
                                <p className="text-danger">{errors?.address}</p>
                              )}
                            </>
                          )}
                      </div>
                      <div
                        id="req_documents-group"
                        className="form-group form-group-lg col-sm-12 formvisible mt-3"
                      >
                        <label>Required Documents (If Any)</label>
                        <textarea
                          type="text"
                          className="form-control"
                          onChange={changeHandlers}
                          name="req_documents"
                          id="req_documents"
                          placeholder="Mention Documents Needed"
                          value={formData?.req_documents}
                        ></textarea>
                        {errors?.req_documents && (
                          <p className="text-danger">{errors?.req_documents}</p>
                        )}
                      </div>
                    </Row>
                  </div>
                </div>
                <div className="modal-action-btn text-left mt-4">
                  <button
                    className="m-2 btn btn-secondary"
                    onClick={handleToggleForm}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    id="book_schedule"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    </>
  );
}
export default CandidaterescheduleList;
